var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticStyle:{"margin":"0 0 25px 0"},attrs:{"fab":"","small":"","bottom":"","right":"","color":"blue","absolute":""}},[_c('v-icon',[_vm._v(" fa-globe-americas ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }